import Swal from "sweetalert2";
import { Icon } from '@iconify/react';

export const formatedPrice = (value) => {
    const formattedValue = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: value <= 100000 ? 2 : 0,
      maximumFractionDigits: value <= 100000 ? 2 : 0,
    }).format(value || 0);
  
    return formattedValue;
};

export const formatTime = (timeString) => {
  if (!timeString) return '';
  const trimmed = timeString.trim();
  // If already in 12-hour format (contains AM or PM), return as-is
  if (/am|pm/i.test(trimmed)) {
    return trimmed.replace(/\s?(am|pm)/i, (match) => ` ${match.trim().toUpperCase()}`);
  }
  // Handle 24-hour format "HH:MM" or "HH:MM:SS"
  const parts = trimmed.split(':');
  if (parts.length < 2) return trimmed;
  const hours = parseInt(parts[0], 10);
  const minutes = parts[1];
  const period = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  return `${formattedHours}:${minutes} ${period}`;
};

export const successAlert = (msg) => {
  Swal.fire({
    icon: "success",
    title: "Done",
    text: msg,
    confirmButtonColor: "#058CBD",
  });
};

export const errorAlert = (msg) => {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: msg,
    confirmButtonColor: "#7066e0",
  });
};

const statusConfig = {
  success: {
    color: "text-green-600 bg-green-100",
    statuses: {
      paid: {
        icon: "mdi:cash-check",
      },
      completed: {
        icon: "mdi:check-circle-outline",
      },
      done: {
        icon: "mdi:check",
      },
      closed: {
        icon: "mdi:lock",
      },
    },
  },
  error: {
    color: "text-red-600 bg-red-100",
    statuses: {
      pending: {
        icon: "mdi:timer-sand",
      },
      failed: {
        icon: "mdi:close-circle-outline",
      },
    },
  },
  warning: {
    color: "text-yellow-600 bg-yellow-100",
    statuses: {
      partial: {
        icon: "mdi:alert-outline",
      },
      warning: {
        icon: "mdi:alert",
      },
      requested: {
        icon: "mdi:account-question",
      },
    },
  },
  info: {
    color: "text-[#058CBD] bg-[#c8ebf7]",
    statuses: {
      saved: {
        icon: "mdi:content-save",
      },
      confirmed: {
        icon: "mdi:check-decagram",
      },
      draft: {
        icon: "mdi:file-document-edit-outline",
      },
      quoted: {
        icon: "mdi:clipboard-text-outline",
      },
      open: {
        icon: "mdi:folder-open-outline",
      },
    },
  },
};

const getStatusType = (status) => {
  const lowercaseStatus = status?.toLowerCase();
  const type = Object.keys(statusConfig).find((type) =>
    Object.keys(statusConfig[type].statuses).includes(lowercaseStatus)
  );

  return type || "error";
};

const getStatusIcon = (status) => {
  const lowercaseStatus = status?.toLowerCase();
  const type = getStatusType(lowercaseStatus);
  return (
    statusConfig[type]?.statuses[lowercaseStatus]?.icon || "mdi:alert-circle"
  );
};

export const renderStatusBadge = (status) => {
  const type = getStatusType(status);
  const { color } = statusConfig[type];
  const icon = getStatusIcon(status);

  return (
    //   <div
    //   className={
    //     "bg-[#E7F7EF]  ease-in-out text-[#0CAF60] capitalize "
    //   }
    // >
    <div
      className={`inline-flex items-center  rounded-lg  hover:scale-105 duration-300 font-normal whitespace-nowrap font-medium ${color} capitalize transition-transform duration-300 ease-in-out px-3 py-2`}
    >
      <Icon icon={icon} className="w-4 h-4 mr-1" />
      {status}
    </div>
  );
};